<template lang="pug">
  .b-members
    ._left
      UserAvatar._image(
        v-for="user in headOfUserList"
        :key="user.id"
        :user="user"
        :size="size"
        )
      ._more(v-if="tailSize" :style="styles")  + {{ tailSize }}
    ._desc(v-if="desc") {{ desc }}
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'UsersTile',
  components: { UserAvatar },
  props: {
    users: {
      type: Array,
      required: true,
    },
    size: Number,
    headSize: {
      type: Number,
      default: 5,
    },
    desc: String,
  },
  computed: {
    styles() {
      if (!this.size) return {};

      const radius = Math.ceil(this.size / 2.75);

      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'border-radius': `${radius}px`,
      };
    },
    headOfUserList() { return this.users.slice(0, this.headSize); },
    tailSize() {
      let tailSize = this.users.length - this.headSize;

      if (tailSize < 0) {
        tailSize = 0;
      }

      return tailSize;
    },
  },
};
</script>

<style scoped lang="scss">
.members {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-middle-gray);
  &__left {
    display: flex;
    align-items: center;
  }
  &__image {
    &:not(:first-child) {
      margin-left: -15px;
    }
  }
  &__more {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    font-family: "Commissioner", sans-serif;
    font-weight: 700;
    margin-left: -15px;
    z-index: 1;
    width: 40px;
    height: 40px;
    border-radius: 16px;
    font-size: 12px;
    background-color: var(--color-dark-gray);
  }
  &__desc {
    font-weight: 500;
    font-size: 14px;
    transition: color 0.3s;
    cursor: pointer;
    &:hover {
      color: var(--color-hover);
    }
  }

  @media (max-width: 1600px) {
    &__image {
      width: 35px;
      height: 35px;
      border-radius: 15px;
    }
    &__desc {
      font-size: 12px;
    }
    &__more {
      width: 35px;
      height: 35px;
      border-radius: 15px;
    }
  }

  @media (max-width: 1366px) {
    &__image {
      width: 32px;
      height: 32px;
      border-radius: 12px;
    }
    &__more {
      width: 32px;
      height: 32px;
      border-radius: 12px;
    }
  }

  @media (max-width: 1024px) {
    grid-area: 1 span; // ?
  }

  @media (max-width: 768px) {
    &__desc {
      font-size: 12px;
    }

    &__image {
      width: 40px;
      height: 40px;
      border-radius: 15px;
    }
    &__more {
      width: 40px;
      height: 40px;
      border-radius: 15px;
    }
  }

  @media (max-width: 360px) {
    &__image {
      width: 32px;
      height: 32px;
      border-radius: 12px;
      &:not(:first-child) {
        margin-left: -10px;
      }
    }
    &__more {
      font-size: 10px;
      width: 32px;
      height: 32px;
      border-radius: 12px;
    }
  }

}
</style>
